import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import WarrantyForHouseWrapper from "@components/layouts/warrantyForHouseWrapper";
import { useDomainContext } from "@hooks/useDomainContext";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function PrivacyPolicyHome(): ReactElement {
    const { domain } = useDomainContext();
    return (
        <WarrantyForHouseWrapper boxShadow="0px -2px 10px #888888">
            <PrivacyPolicy
                category={domain?.categories[0]?.name}
                domain={domain.niceName}
            />
        </WarrantyForHouseWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
